import _ from 'lodash'

import { markdown } from 'markdown'

import md from '~/help/Help.md'

import getSlug from 'speakingurl'

/**
 * M2-125: Help.md describes password rules that are server settings — expiry and the
 * reuse history, both switched by jwt.use_password_expiration (off by default).
 * photon-cp.blade.php passes them as window.photonSettings; a line carrying a
 * {{placeholder}} gets the value filled in, or is dropped when the setting is off (null).
 *
 * @param   {string}  source
 * @return  {string}
 */
function applyHelpSettings(source) {
  const values = {
    password_expiration_days: _.get(window, 'photonSettings.passwordExpirationDays'),
    password_history: _.get(window, 'photonSettings.passwordHistory'),
  }

  return source
    .split('\n')
    .filter(line =>
      _.every(values, (value, name) => value || !line.includes(`{{${name}}}`))
    )
    .map(line =>
      line.replace(/{{(\w+)}}/g, (match, name) =>
        _.has(values, name) ? values[name] : match
      )
    )
    .join('\n')
}

export default {
  /**
   * Set the component data
   *
   * @return  {object}
   */
  data() {
    return {
      helpPages: {},
    }
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    $helpHTML() {
      const htmlString = markdown.toHTML(applyHelpSettings(md), 'Maruku')

      return $.parseHTML(htmlString)
    },

    pages() {
      const moduleTableName = this.$route.params.moduleTableName

      if (_.has(this.helpPages, moduleTableName)) {
        return this.helpPages[moduleTableName]
      }

      return []
    },

    allPages() {
      const moduleTableName = this.$route.params.moduleTableName
      if (_.has(this.helpPages, 'add-to-all')) {
        return this.helpPages['add-to-all']
      }

      return []
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    createHelpPages() {
      let helpObject = {}

      let pageIndex = ''

      let pageSection = {}

      let isFirst = true

      $(this.$helpHTML).each(function() {
        if ($(this).is('h1')) {
          return
        }

        if ($(this).is('h2')) {
          if (!_.isEmpty(pageSection)) {
            helpObject[pageIndex].push(pageSection)

            pageSection = {}

            isFirst = true
          }

          pageIndex = $(this)
            .find('code')
            .text()

          helpObject[pageIndex] = []

          return
        }

        if ($(this).is('h3')) {
          if (!_.isEmpty(pageSection)) {
            helpObject[pageIndex].push(pageSection)

            pageSection = {}
          }

          pageSection['title'] = $(this).text()

          pageSection['slug'] = getSlug(pageSection['title'])

          pageSection['isFirst'] = isFirst

          pageSection['content'] = ''

          isFirst = false

          return
        }

        if ($(this).prop('outerHTML') !== undefined) {
          pageSection['content'] += $(this).prop('outerHTML')
        }
      })

      if (!_.isEmpty(pageSection)) {
        helpObject[pageIndex].push(pageSection)

        pageSection = {}
      }

      return helpObject
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted: function() {
    this.helpPages = this.createHelpPages()
  },
}
